import './confirmation-dialog.scss'

import { BaseComponent } from '../../common/base-component'
import { Component } from 'vue-property-decorator'

@Component({
  template: require('./confirmation-dialog.pug'),
  props: {
    width: {
      type: Number,
      default: 480
    },
    customClass: {
      type: String,
      default: 'delete-warning_dialog_wrapper'
    },
    active: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      required: true
    },
    cancelText: {
      type: String,
      default: ''
    },
    confirmButtonType: {
      type: String,
      default: 'is-danger'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    canCancel: {
      type: Array,
      default: () => ['escape', 'outside']
    }
  },
  watch: {
    active(value: boolean): void {
      this.isModalActiveInternal = value
    }
  }
})
export class ConfirmationDialogComponent extends BaseComponent {
  width: number
  customClass: string
  active: boolean
  title: string
  description: string
  confirmText: string
  cancelText: string
  confirmButtonType: string
  showCancelButton: boolean
  canCancel: string[]

  isModalActiveInternal = false

  handleClose(): void {
    this.isModalActiveInternal = false
    this.$emit('update:active', false)
    this.$emit('close')
  }

  handleConfirm(): void {
    this.$emit('confirm')
    this.handleClose()
  }
}
